'use client';

import { useEffect } from 'react';

export function PwaRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if ('caches' in window) {
      window.caches
        .keys()
        .then((keys) =>
          Promise.all(
            keys
              .filter((key) => key !== 'kontora-v3')
              .map((key) => window.caches.delete(key)),
          ),
        )
        .catch(() => undefined);
    }

    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        void reg.update().catch(() => undefined);
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        // eslint-disable-next-line no-console
        console.info('[pwa] Service Worker registriert:', reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[pwa] Service Worker Registrierung fehlgeschlagen:', err);
      });
  }, []);

  return null;
}
